import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Gallery from "./pages/Gallery";
import NSS from "./pages/NSS";
import Research from "./pages/Research";
import SSR from "./pages/SSR";
import StudentSurvey from "./pages/StudentSurvey";
import Policy from "./pages/Policy";
import Statutory from "./pages/Statutory";
import Contact from "./pages/Contact";
import AboutCollege from "./pages/AboutCollege";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/nss" element={<NSS />} />
          <Route path="/research" element={<Research />} />
          <Route path="/ssr" element={<SSR />} />
          <Route path="/student" element={<StudentSurvey />} />
          <Route path="/policy" element={<Policy />} />
          <Route path="/statutory" element={<Statutory />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about-college" element={<AboutCollege />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
